import * as featureActions from './actions';
import { IAlfrescoDocumentsStoreState, initialState } from './state';
import { createReducer, Action, ActionReducer, on, ReducerTypes } from '@ngrx/store';
import { withEntityReducer } from '@core-lib/store';

// declare our fully typed reducer
export function createAlfrescoDocumentsReducer<A extends Action = Action>(
	initialState,
	...ons: ReducerTypes<IAlfrescoDocumentsStoreState, any>[]
): ActionReducer<IAlfrescoDocumentsStoreState, A> {
	return createReducer(initialState, ...ons);
}

const featureReducer = createAlfrescoDocumentsReducer(
	initialState,

	...withEntityReducer<IAlfrescoDocumentsStoreState>('coordonneesBancairesDocuments', featureActions.CoordonneesBancairesDocsActions),

	on(featureActions.resetAction, state => (state = initialState))
);

export function alfrescoDocumentsStoreReducer(state: IAlfrescoDocumentsStoreState, action: Action): IAlfrescoDocumentsStoreState {
	return featureReducer(state, action);
}
